/// <amd-module name="Test/TestPlansHubRefresh/TestCaseLinkedItems/Redux/TestCaseLinkedItemsModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ActionsUnion } from "redux/Utils/ActionHelper";
import { TestCaseLinkedItemsSaga } from "./TestCaseLinkedItemsSaga";
import { TestCaseLinkedItemsActions } from "./TestCaseLinkedItemsActions";
import { TestCaseLinkedItemsReducer } from "./TestCaseLinkedItemsReducer";
import { ILinkedItemsAwareState } from "./TestCaseLinkedItemsContracts";

export function getLinkedItemsModule(testCaseId: number, planId: number): ISagaModule<ILinkedItemsAwareState> {
    const initialActions: ActionsUnion<typeof TestCaseLinkedItemsActions>[] = [];
    initialActions.push(TestCaseLinkedItemsActions.getInitialDataForLinkedPanel(testCaseId, planId));
    return {
        id: "linkeditems",
        reducerMap: {
            linkedItemsState: TestCaseLinkedItemsReducer
        },
        sagas: [TestCaseLinkedItemsSaga],
        initialActions: initialActions
    };
}
